/**
 * Tipos de documento que aceitam timbrado.
 *
 * A chave é estável e vive aqui porque três lugares precisam concordar sobre ela:
 * o `Letterhead.documentTypes` (array de strings no Postgres), o service que
 * resolve qual timbrado usar ao gerar o PDF, e a tela de cadastro que precisa
 * mostrar o rótulo em português.
 *
 * Cada chave corresponde a um template de `@mediardex/pdf-templates`.
 */
export const LETTERHEAD_DOCUMENT_TYPES = {
    // Clínicos — o que o paciente leva na mão
    PRESCRIPTION: 'Receituário',
    MEDICAL_CERTIFICATE: 'Atestado',
    MEDICAL_REPORT: 'Laudo',
    EXAM_ORDER: 'Pedido de exames',
    EXAM_RESULTS: 'Resultado de exames',
    CONSULTATION: 'Consulta',
    EVOLUTION: 'Evolução',
    REFERRAL: 'Encaminhamento',
    ORDER: 'Pedido/Procedimento',
    CLIENT: 'Ficha do paciente',
    // Comerciais e financeiros
    BUDGET: 'Orçamento',
    SALE_SIMULATION: 'Simulação de venda',
    STATEMENT_RECEIPT: 'Recibo de pagamento',
    REFUND_RECEIPT: 'Recibo de estorno',
    PAYOUT_BATCH_RECEIPT: 'Recibo de repasse',
    COMMISSION_STATEMENT: 'Demonstrativo de comissão',
    PAYSLIP: 'Contracheque',
    // Relatórios
    GENERIC_REPORT: 'Relatório',
    PARTNER_COMPARISON: 'Comparativo de parceiros',
    BANK_RECONCILIATION: 'Conciliação bancária',
    // Contábeis
    DRE: 'DRE',
    BALANCETE: 'Balancete',
    RAZAO: 'Razão',
    LIVRO_DIARIO: 'Livro diário',
    BALANCO_PATRIMONIAL: 'Balanço patrimonial',
    PLANO_DE_CONTAS: 'Plano de contas',
    FLUXO_CAIXA: 'Fluxo de caixa',
};
export const LETTERHEAD_DOCUMENT_TYPE_KEYS = Object.keys(LETTERHEAD_DOCUMENT_TYPES);
/**
 * Agrupamento usado só pela tela de cadastro, para não despejar 26 caixas de
 * seleção numa lista corrida.
 */
export const LETTERHEAD_DOCUMENT_GROUPS = [
    {
        label: 'Clínicos',
        types: [
            'PRESCRIPTION',
            'MEDICAL_CERTIFICATE',
            'MEDICAL_REPORT',
            'EXAM_ORDER',
            'EXAM_RESULTS',
            'CONSULTATION',
            'EVOLUTION',
            'REFERRAL',
            'ORDER',
            'CLIENT',
        ],
    },
    {
        label: 'Comerciais e financeiros',
        types: [
            'BUDGET',
            'SALE_SIMULATION',
            'STATEMENT_RECEIPT',
            'REFUND_RECEIPT',
            'PAYOUT_BATCH_RECEIPT',
            'COMMISSION_STATEMENT',
            'PAYSLIP',
        ],
    },
    {
        label: 'Relatórios',
        types: ['GENERIC_REPORT', 'PARTNER_COMPARISON', 'BANK_RECONCILIATION'],
    },
    {
        label: 'Contábeis',
        types: [
            'DRE',
            'BALANCETE',
            'RAZAO',
            'LIVRO_DIARIO',
            'BALANCO_PATRIMONIAL',
            'PLANO_DE_CONTAS',
            'FLUXO_CAIXA',
        ],
    },
];
//# sourceMappingURL=document-types.js.map